module.exports = __webpack_public_path__ + "media/images/countryrect/tc-2db92a4585f7596651f4eac3e1e05c92.svg";